module.exports = __webpack_public_path__ + "static/peopleFingerStar-1e6c551921b63ecf360148b4523a6908.jpg";